(function GHighscorePanel2DataIIFE(){

  var SendableResourceType = {
    LifeShare:     'life',
    LifeRequest:   'lifeRequest',
    ContextChange: 'contextChange',
  };

  G.HighscorePanel2Data = {
    SendableResourceType: SendableResourceType,
    getResourceCooldownSeconds: getResourceCooldownSeconds,
    repositionCurrentPlayerToTop4: repositionCurrentPlayerToTop4
  };

  return;


  function getResourceCooldownSeconds(userId, resourceType) {
    return Math.ceil(G.saveState.getSecondsUntilResourceCanBeSent(userId, resourceType));
  }

  function repositionCurrentPlayerToTop4(entriesArray) {
    var currentPlayerIndex = findIndex(entriesArray, isCurrentUser);
    if (currentPlayerIndex >= 0) {
      if (!isTop3(entriesArray[currentPlayerIndex])) {
        var newPosition = 0;
        while (isTop3(entriesArray[newPosition]) && !isCurrentUser(entriesArray[newPosition])) {
          ++newPosition;
        }
        if (newPosition < currentPlayerIndex) {
          var result = entriesArray.slice();
          var currentPlayerEntry = result.splice(currentPlayerIndex, 1)[0];
          result.splice(newPosition, 0, currentPlayerEntry);
          return result;
        }
      }
    }
    return entriesArray;

    function isTop3(entry) {
      return entry.rank <= 3;
    }
    function findIndex(array, predicate) {
      for (var i = 0; i < array.length; ++i) {
        if (predicate(array[i])) return i;
      }
      return -1;
    }
    function isCurrentUser(entry) {
      return Boolean(entry.isCurrentUser);
    }
  }


}());
